import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import MusicPlayer, { stopAllMusic } from '../../components/MusicPlayer';
import supabase from '../../supabase/supabase';

const FALLBACK_TRACKS = [
  { id: 'romantic-piano', title: 'Romantic Piano', artist: 'DayClap', emoji: '🎹', is_premium: false, audio_url: '' },
  { id: 'love-ballad', title: 'Love Ballad', artist: 'DayClap', emoji: '💕', is_premium: false, audio_url: '' },
  { id: 'candlelight-jazz', title: 'Candlelight Jazz', artist: 'DayClap', emoji: '🎷', is_premium: false, audio_url: '' },
  { id: 'acoustic-love', title: 'Acoustic Love', artist: 'DayClap', emoji: '🎸', is_premium: false, audio_url: '' },
];

const CouplesMusic = ({ data, onNext }) => {
  const [tracks, setTracks] = useState(FALLBACK_TRACKS);

  useEffect(() => {
    const loadTracks = async () => {
      if (!supabase) return;
      try {
        const { data: dbTracks } = await supabase
          .from('music_tracks')
          .select('*')
          .in('category', ['couples', 'both'])
          .eq('is_active', true)
          .order('sort_order', { ascending: true });
        if (dbTracks && dbTracks.length > 0) setTracks(dbTracks);
      } catch (e) { /* use fallback */ }
    };
    loadTracks();
  }, []);

  // Stop music when leaving this step
  useEffect(() => {
    return () => {
      stopAllMusic();
    };
  }, []);

  return (
    <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-1">Add Music 🎵</h2>
      <p className="text-gray-500 text-sm mb-6">Tap play to preview, then select your track</p>

      <div className="space-y-3">
        {tracks.map((track, idx) => (
          <motion.div
            key={track.id}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: idx * 0.05 }}
          >
            <MusicPlayer
              audioUrl={track.audio_url}
              title={track.title}
              artist={track.artist}
              emoji={track.emoji}
              isPremium={track.is_premium}
              trackId={track.id}
              isSelected={data.musicTrack === track.id}
              onSelect={() => onNext({ musicTrack: track.id, musicTitle: track.title })}
            />
          </motion.div>
        ))}
      </div>

      <button
        onClick={() => {
          stopAllMusic();
          onNext({ musicTrack: data.musicTrack || '', musicTitle: data.musicTitle || '' });
        }}
        className="w-full mt-6 bg-gradient-to-r from-purple-500 to-violet-500 text-white font-bold py-4 rounded-xl shadow-lg shadow-purple-200"
      >
        {data.musicTrack ? 'Continue →' : 'Skip — No Music'}
      </button>
    </motion.div>
  );
};

export default CouplesMusic;